// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"e9955f0d","361":"400d3fcb","384":"b2265899","647":"416d3fb2","687":"621c728d","930":"c16ad79f","946":"fec1d12e","984":"fada8d14"}[chunkId] + ".chunk.js";
};